export const commercialQuotesEs = {
  customerText: { introduction: 'Presentación para el cliente', recommendation: 'Por qué recomendamos esta opción', hint: 'Opcional. Este texto se verá en el link y en el PDF. Dejalo vacío para quitarlo.', cancel: 'Cancelar', save: 'Guardar texto', advisor: 'Tu asesor', includes: 'Tu viaje incluye', why: 'Por qué te lo recomendamos' },
  presentation: {"title": "Presentación de cotizaciones", "hint": "Todos los datos son opcionales. Se aplican a nuevas publicaciones; las versiones enviadas conservan su información.", "identity": "Logo y datos de la agencia", "readOnly": "Solo un administrador puede modificar estos datos.", "hours": "Horarios de atención", "registration": "Habilitación / registro de la agencia", "paymentMethods": "Formas de pago (información comercial)", "terms": "Condiciones generales de las cotizaciones", "branches": "Sucursales", "branchname": "Nombre de la sucursal", "branchaddress": "Dirección", "branchmapUrl": "Enlace a la ubicación (https://…)", "removeBranch": "Quitar sucursal", "addBranch": "Agregar sucursal", "preview": "Vista previa de la información pública", "loadError": "No pudimos cargar la configuración.", "saveError": "No pudimos guardar. Revisá los campos y los enlaces de ubicación y reintentá; tus cambios siguen aquí.", "saved": "Configuración guardada.", "save": "Guardar presentación", "saving": "Guardando…"},
  booking: {
    previous: 'Anteriores', next: 'Siguientes',
    partyChanged: 'Las edades o la composición cambiaron. Abrí el buscador para actualizar esta opción con los datos actuales.',
    caseClientRequired: 'Para solicitar una reserva en un motor, asociá primero un cliente al caso. Podés seguir preparando el viaje y registrar gestiones manuales.',
    'title': 'Preparar reservas',
    'loading': 'Cargando…',
    'intro': 'Revisá los servicios y abrí cada reserva con sus datos precargados. Los motores comprueban el costo y las condiciones actuales antes de reservar. La venta acordada en esta propuesta se conserva; los cobros se gestionan en Power.',
    'selectionHint': 'La selección del cliente se aplica a las opciones que todavía existen. Revisá los servicios y condiciones actuales antes de reservar: esta selección no acepta cambios posteriores ni crea reservas.',
    'selectionChanged': 'Alguna opción elegida cambió o fue eliminada. Revisá la selección y elegí su reemplazo en el borrador.',
    'applySelection': 'Usar selección y preparar reservas',
    'prepareFailed': 'No pudimos preparar este servicio. Comprobá que el borrador esté guardado, revisá los perfiles o abrí el buscador para actualizar la opción. También podés registrar una gestión manual.',
    'profiles': 'Viajeros del caso',
    'profilesHint': 'Asigná cada lugar del viaje a su perfil. Los datos personales se completan una vez en el caso y cada servicio pide solamente lo que necesita.',
    'adult': 'Adulto {{number}}',
    'minor': 'Menor {{number}} · {{age}} años',
    'unassigned': 'Asignar después',
    'manageProfiles': 'Completar perfiles del caso',
    'commercialPrice': 'Venta acordada',
    'quotedCost': 'Costo cotizado',
    'toConfirm': 'A confirmar',
    'prepare': 'Revisar y reservar',
    'search': 'Buscar otra opción',
    'manual': 'Registrar gestión manual',
    'manualHint': 'Registrá una gestión realizada por fuera de estos motores, con su proveedor y estado real. Guardar este registro no solicita ni cancela una reserva.',
    'manualError': 'No pudimos confirmar el guardado. Reintentar conserva el mismo registro; también podés cerrar y consultar el historial antes de continuar.',
    'provider': 'Proveedor',
    'reference': 'Localizador o referencia',
    'status': 'Estado real',
    'note': 'Nota interna',
    'saveManual': 'Guardar registro',
    'retry': 'Reintentar',
    'close': 'Cerrar',
    'history': 'Reservas de cotizaciones',
    fromQuote: 'Origen: cotizaciones',
    'historyHint': 'Cada reserva se gestiona desde el caso con sus condiciones actuales, aunque la propuesta esté archivada. Cancelar y tomar otra reserva son acciones separadas.',
    'historyTruncated': 'Se muestran las reservas más recientes.',
    'noBookings': 'Todavía no hay reservas registradas.',
    'loadFailed': 'No pudimos cargar las reservas. Actualizá para volver a intentar.',
    'verifyFirst': 'Hay un intento pendiente de verificación. Abrilo para consultar o conciliar su resultado antes de volver a reservar este servicio.',
    'manage': 'Abrir reserva / continuar',
    'editManual': 'Actualizar registro',
    'refresh': 'Actualizar',
    'chooseServices': 'Elegí las opciones del viaje para preparar sus reservas.',
    'states': {
      'pending': 'Pendiente',
      'draft': 'Pendiente',
      'quoting': 'Comprobando tarifa',
      'quoted': 'Tarifa preparada',
      'booking': 'En proceso',
      'booked': 'Confirmado',
      'confirmed': 'Confirmado',
      'held': 'Retenido',
      'uncertain': 'Por verificar',
      'unknown': 'Por verificar',
      'rejected': 'Rechazado',
      'failed': 'No se pudo reservar',
      'unavailable': 'No disponible',
      'expired': 'Vencido',
      'discarded': 'Descartado',
      'cancelled': 'Cancelado'
    }
  },
  review: {
    belowCost: 'Si mantenés la venta, este servicio quedará por debajo del costo.',
    title: 'Actualizar disponibilidad y precios',
    hint: 'Revisamos búsquedas sin reservar. El cliente conserva su propuesta publicada. Aplicar un resultado actualiza solamente el borrador.',
    running: 'Consultando',
    completed: 'Revisión lista',
    interrupted: 'Revisión interrumpida',
    refresh: 'Revisar todas las opciones',
    error: 'No se pudo completar. Reintentá o abrí el buscador; no significa que el servicio esté agotado.',
    stale:
      'El borrador cambió. Solo se pueden aplicar resultados de servicios y participantes que siguen iguales; revisá nuevamente si hace falta.',
    pending: 'Pendiente',
    available: 'Encontramos la misma opción',
    alternatives: 'Hay alternativas para revisar',
    not_found: 'No encontrada en esta búsqueda',
    unverified: 'Sin verificar',
    manual: 'Gestión manual',
    changed: 'Servicio actualizado',
    unknown: 'A confirmar',
    cost: 'Costo',
    sale: 'Venta propuesta',
    mapping: 'Requiere volver al buscador para comprobar vigencia y asignar participantes.',
    captured: 'Consultado',
    expired: 'Precio de búsqueda anterior: actualizar antes de reservar.',
    searchOnly: 'Precio de búsqueda; no es una reserva.',
    partial: 'Respuesta parcial. Los proveedores que no respondieron siguen sin verificar.',
    same: 'Mismo servicio y condiciones detectados; revisar los importes.',
    material: 'Cambian datos o condiciones. Si afectan lo vendido, publicá la actualización y acordala con el cliente.',
    adopt: 'Usar y respetar mi criterio de venta',
    absorb: 'Usar conservando venta y seña',
    search: 'Abrir buscador completo',
    manualAction: 'Resolver manualmente',
    close: 'Volver a la cotización',
  },
  pdf: {
    download: 'Descargar PDF de mi selección',
    preparing: 'Preparando PDF…',
    failed: 'No pudimos preparar el PDF. Reintentá en unos instantes o contactá a la agencia.',
  },
  selection: {
    title: 'Selecciones del cliente',
    advance: 'Enviar mi selección por WhatsApp',
    save: 'Compartir mi selección',
    saving: 'Guardando selección…',
    consult: 'Consultar por WhatsApp',
    call: 'Contactar a la agencia',
    open: 'Abrir WhatsApp',
    saved: 'Tu selección quedó guardada en la agencia.',
    sendHint: 'Enviá el mensaje en WhatsApp para conversar con tu asesor. Esto todavía no reserva servicios.',
    contactHint: 'Tu asesor ya puede ver la selección. Contactá a la agencia para continuar.',
    failed: 'No pudimos confirmar el guardado. Podés reintentar o consultar por WhatsApp.',
    oldVersion:
      'Guardamos tu selección de esta versión. Hay una propuesta más nueva; podés revisarla o consultarlo con tu asesor.',
    latest: 'Ver actualización',
    inquiryMessage: 'Hola, quiero consultar por «{{title}}» (versión {{version}}). Referencia {{reference}}.',
    selectionMessage:
      'Hola, quiero avanzar con mi selección de «{{title}}» (versión {{version}}). Referencia {{reference}}. Confirmemos disponibilidad y condiciones.',
    statusHint: 'Guardar una selección no significa que el cliente haya enviado un mensaje ni solicitado una reserva.',
    loading: 'Cargando selecciones…',
    retry: 'Reintentar',
    loadFailed: 'No pudimos cargar las selecciones.',
    empty: 'Todavía no hay selecciones guardadas.',
    received: 'Mensaje recibido',
    savedOnly: 'Selección guardada',
    previousVersion: 'Versión anterior',
    excluded: 'No incluido',
    toConfirm: 'A confirmar',
    refresh: 'Actualizar',
    close: 'Cerrar',
  },
  publication: {
    title: 'Publicar y compartir',
    snapshot: 'Publicar congela una versión. Los cambios del borrador no cambian el link hasta que vuelvas a publicar.',
    linkFailed: 'La versión quedó publicada, pero no se pudo crear el link. Usá Crear link público para reintentar.',
    failed: 'No pudimos completar la acción. Revisá el guardado, los precios y tu acceso al caso, y reintentá.',
    archived: 'Esta propuesta está archivada. El cliente puede consultar su contenido y contactar a la agencia.',
    pricingInvalid: 'Revisá los descuentos y repartos en Precios antes de publicar.',
    belowCost: 'Confirmo publicar esta venta por debajo del costo conocido.',
    publish: 'Publicar nueva versión',
    copyNow: 'Link creado. Guardalo para volver a compartirlo.',
    open: 'Abrir vista del cliente',
    copy: 'Copiar link',
    copyFailed: 'No se pudo copiar. Abrí la vista del cliente y copiá la dirección.',
    linkActive: 'El link actual está activo y muestra la última versión publicada.',
    linkOff: 'El acceso público está deshabilitado.',
    rotate: 'Crear otro link e invalidar el anterior',
    createLink: 'Crear link público',
    revoke: 'Deshabilitar link',
    rotateHint: 'Crear otro link invalida el anterior. Publicar una nueva versión conserva el link existente.',
    restore: 'Restaurar propuesta',
    archive: 'Archivar propuesta',
    history: 'Versiones publicadas',
    revision: 'Borrador',
    close: 'Cerrar',
  },
  publicView: {
    chooseOption: 'Elegir esta opción', viewHotelPhoto: 'Ver foto del hotel', closePhoto: 'Cerrar', directFlight: 'Vuelo directo', stopCount_one: '{{count}} escala', stopCount_other: '{{count}} escalas', baggageUnknown: 'Equipaje a confirmar con tu asesor', bagWeight: 'hasta {{weight}} kg por pieza',
    bags: { CHECKED: {general: 'Incluye valija para despachar', none: 'No incluye valija para despachar', included_one: '{{count}} valija para despachar incluida', included_other: '{{count}} valijas para despachar incluidas'}, CARRY_ON: {general: 'Incluye equipaje de mano', none: 'No incluye equipaje de mano', included_one: '{{count}} pieza de equipaje de mano incluida', included_other: '{{count}} piezas de equipaje de mano incluidas'}, PERSONAL_ITEM: {general: 'Incluye artículo personal', none: 'No incluye artículo personal', included_one: '{{count}} artículo personal incluido', included_other: '{{count}} artículos personales incluidos'} },

    showSummary: 'Ver desglose y condiciones de pago',
    hideSummary: 'Ocultar desglose',
    noPhoto: 'Foto no disponible',
    map: 'Ver ubicación',
    stops: 'escalas',
    operated: 'Operado por',
    terminal: 'Terminal',
    connection: 'Conexión',
    customerTerms: 'Condiciones de esta propuesta',
    refund: 'Reembolso',
    changes: 'Cambios',
    unknown: 'A confirmar',
    allowed: 'Permitido',
    notAllowed: 'No permitido',
    refundPenalty: 'Cargo de reembolso',
    changePenalty: 'Cargo por cambio',
    separateTickets: 'Este itinerario combina billetes separados.',
    itinerary: 'Ver itinerario día por día',
    day: 'Día',
    includes: 'Incluye',
    conditions: 'Ver condiciones',
    optional: 'Opcional',
    included: 'Incluido',
    withoutOptional: 'No incluir este servicio',
    chosen: 'Elegida',
    calculating: 'Calculando…',
    toConfirm: 'A confirmar',
    samePrice: 'Sin diferencia de precio',
    forGroup: 'para el grupo',
    retry: 'Reintentar',
    calculationFailed: 'No pudimos actualizar el importe. Podés reintentar o contactar a la agencia.',
    loading: 'Cargando propuesta',
    unavailable:
      'No pudimos abrir esta propuesta. El link puede haber sido deshabilitado o cambiado; consultá a tu asesor.',
    contact: 'Consultar',
    yourTrip: 'Tu propuesta de viaje',
    travelers: 'viajeros',
    published: 'Publicada',
    searchOnly: 'Precios de búsqueda sujetos a reconfirmación. Esta propuesta no constituye una reserva.',
    archived: 'Propuesta archivada. Podés consultar el contenido y contactar a la agencia.',
    seeLatest: 'Ver actualización',
    updated: 'Hay una nueva versión publicada. Tus elecciones actuales corresponden a la versión anterior.',
    summary: 'Tu viaje',
    groupTotal: 'Total del grupo con las opciones elegidas',
    families: 'Por familia o grupo',
    rooms: 'Ver por habitación',
    passengerTypes: 'Ver por ADT / CHD / INF',
    travelGroup: 'Grupo del viaje',
    otherTravelers: 'Otros viajeros',
    sharedServices: 'Servicios compartidos',
    unassigned: 'Sin grupo asignado',
    deposit: 'Seña prevista',
    balance: 'Saldo previsto',
    dateToConfirm: 'Fecha a confirmar',
    paymentHint: 'Son condiciones previstas; no indican pagos realizados.',
    atDestination: 'A pagar directamente en destino',
    agencyWebsite: 'Sitio de la agencia',
    baggage: { CHECKED: 'Equipaje despachado', CARRY_ON: 'Equipaje de mano', PERSONAL_ITEM: 'Artículo personal' },
  },
  libraryTransferLinkHint:
    'El traslado puede seguir al hotel o vuelo elegido en la propuesta. Si falta esa selección o su ubicación, completás el punto en el buscador.',
  libraryOriginLink: 'Origen del traslado',
  libraryDestinationLink: 'Destino del traslado',
  libraryFixedPoint: 'Lugar guardado / completar en búsqueda',
  libraryMissingLink: 'La referencia fue quitada: elegí otra o un lugar independiente',
  libraryLinks: { hotel: 'Hotel elegido', 'flight-arrival': 'Llegada de vuelo', 'flight-departure': 'Salida de vuelo' },

  libraryTravelerPositions: 'Posiciones de viajeros (1,2,...)',
  library: 'Biblioteca',
  libraryTemplates: 'Plantillas de viaje',
  libraryHotels: 'Hoteles preferidos y favoritos',
  libraryFind: 'Buscar por nombre o destino',
  libraryArchived: 'Archivados',
  libraryCreate: 'Crear plantilla',
  librarySaveDraft: 'Guardar esta propuesta como plantilla',
  libraryHotelHint:
    'Los favoritos son personales. Los preferidos compartidos pertenecen a la agencia. La categoría comercial es independiente de las estrellas.',
  libraryFindHotel: 'Buscar un hotel para guardar',
  librarySaveHotel: 'Guardar hotel',
  libraryLoadError: 'No pudimos cargar la biblioteca. Podés reintentar y seguir trabajando.',
  libraryEmpty: 'Todavía no hay elementos con estos filtros.',
  libraryShared: 'Agencia',
  libraryPersonal: 'Personal',
  libraryRank: 'Orden (menor primero)',
  libraryUse: 'Usar plantilla',
  libraryCopy: 'Crear copia personal',
  libraryRestore: 'Restaurar',
  libraryArchive: 'Archivar',
  libraryPrevious: 'Anterior',
  libraryNext: 'Siguiente',
  libraryReview: 'Revisar estructura reutilizable',
  libraryVisibility: 'Visibilidad',
  librarySave: 'Guardar',
  libraryUseHint:
    'Se agregarán los servicios a esta propuesta con los viajeros actuales. Elegí la fecha de llegada; después buscá precios actualizados en cada servicio.',
  libraryUseCircuitHint:
    'Elegí una fecha orientativa para buscar. Seleccioná una salida real del circuito para calcular las noches y servicios previos y posteriores.',
  librarySearchDate: 'Fecha orientativa de salida',
  libraryArrival: 'Llegada al primer destino',
  libraryCommercialCategory: 'Categoría comercial',
  libraryCategory: { premium: 'Premium', value: 'Calidad-precio', economy: 'Económico' },
  libraryRecipeHint:
    'Guardamos necesidades, fechas relativas y opciones. Revisá los grupos relativos: no se copian pasajeros, precios, condiciones de tarifas ni proveedores obligatorios. Día 0 es la fecha de referencia.',
  libraryAnchor: 'Referencia de fechas',
  libraryCircuitAnchor: 'Salida real del circuito',
  libraryOrigin: 'Origen / punto de recogida',
  libraryDestination: 'Destino',
  libraryDay: 'Día relativo (0 = referencia)',
  libraryNights: 'Noches / duración en días',
  libraryParticipants: 'Participantes relativos',
  libraryGroup: {
    all: 'Todos los viajeros',
    room: 'Habitación',
    family: 'Familia',
    travelers: 'Viajeros por posición',
  },
  libraryGroupNumber: 'Número de grupo',
  libraryInstructions: 'Descripción de la necesidad',
  libraryAddBlock: 'Agregar bloque',
  librarySaveError:
    'No pudimos guardar. Revisá los campos; si otro asesor lo modificó, cerrá y volvé a abrir el elemento para usar la versión actual.',
  libraryInvalidDate: 'Elegí una fecha válida.',
  libraryMissingGroup:
    'Falta una habitación o familia de la plantilla. Completá los grupos del caso o ajustá una copia de la plantilla.',
  libraryTooLarge: 'La propuesta supera el límite de 100 bloques.',
  libraryPending: 'Pendiente de cotizar.',
  librarySearchService: 'Buscar servicio',
  libraryPartyLocked:
    'La búsqueda corresponde al grupo de este servicio. Para cambiar sus viajeros, volvé a la propuesta.',
  libraryQuickHotels: 'Acceso rápido a preferidos y favoritos',
  libraryAllHotels: 'Buscar todos los hoteles',
  libraryAvailabilityHint:
    'Cada hotel se consulta para las fechas y habitaciones actuales. Si no tiene disponibilidad, podés buscar todos los resultados.',

  internalNote: 'Referencia interna del asesor',
  circuitReferencePrice:
    'Precio por persona o indicativo. Definí la venta comercial; el total para esta ocupación se comprobará al reservar.',
  circuitItineraryMissing: 'El proveedor no devolvió un itinerario completo. Podés completar la descripción.',
  circuitPlan: 'Organizar viaje alrededor del circuito',
  circuitFixedDates:
    'La salida del circuito permanece fija. Las noches adicionales son servicios separados; los hoteles y traslados incluidos no se agregan otra vez.',
  circuitChooseDeparture: 'Elegí una salida con fechas para organizar el viaje.',
  preNights: 'Noches antes del circuito',
  postNights: 'Noches después del circuito',
  circuitTravelDates: 'Llegada al destino: {{arrival}} · Salida del destino: {{departure}}',
  circuitLinkDates: 'Relacionar fechas con un circuito',
  circuitIndependentDates: 'Fechas independientes',
  circuitDatesChanged:
    'Revisá esta opción para las fechas del viaje: {{dates}}. Conserva su precio y sus fechas originales.',
  circuitSearchAgain: 'Buscar otra opción',
  circuitUseFlightArrival: 'Ajustar noches a la llegada del {{date}}',
  circuitFlightArrivalHint:
    'El vuelo debe llegar el {{date}}. Elegí la fecha de salida considerando duración y cambios de día. Regreso previsto: {{end}}.',
  circuitFlightReturnHint: 'Salida de regreso prevista: {{date}}.',
  circuitExtraReference:
    'Referencia del catálogo. Revisá participantes, condiciones y precio total antes de agregarlo. No se solicita una reserva.',
  circuitAddExtra: 'Preparar adicional',
  circuitAddOptional: 'Ofrecer como opcional',
  circuitItinerary: 'Ver itinerario día por día',
  circuitIncluded: 'Incluido en el circuito',
  circuitDay: 'Día {{day}}',
  circuitCategories: 'Categorías y hoteles previstos',
  circuitCategoriesHint:
    'La categoría elegida es la de la salida capturada. Para cambiarla, agregá otra alternativa desde el buscador.',
  circuitOccupancyRange: 'Ocupación: {{min}}–{{max}} por habitación',
  circuitExtras: 'Suplementos y excursiones opcionales',
  circuitAgeRange: 'Edades {{from}}–{{to}}',
  circuitMaxNights: 'Máximo de noches: {{count}}',
  circuitAdvanceDays: 'Anticipación mínima en días: {{count}}',
  circuitTransferDetails: 'Requiere datos del traslado',
  circuitAfterBooking: 'Contratable después de reservar',
  circuitAtBooking: 'Contratable al reservar',
  circuitRoles: {
    'pre-hotel': 'Hotel antes',
    'post-hotel': 'Hotel después',
    'arrival-transfer': 'Traslado de llegada',
    'departure-transfer': 'Traslado de salida',
    'outbound-flight': 'Vuelo de ida',
    'return-flight': 'Vuelo de vuelta',
    'roundtrip-flight': 'Vuelos ida y vuelta',
  },
  circuitUnits: {
    passenger: 'Por pasajero',
    room: 'Por habitación',
    booking: 'Por reserva',
    night: 'Por noche',
  },
  searchGround: 'Buscar otros servicios',
  addGroundOption: 'Agregar a la propuesta',
  insuranceAgeBasedPrice: 'Precio calculado con las edades de búsqueda. Los adultos sin edad se estiman en 30 años; la tarifa se revisa con las edades reales antes de reservar.',
  groundAlternative: 'Otra opción de servicio',
  groundAdded: 'Servicio agregado. Podés seguir eligiendo alternativas.',
  groundCapturing: 'Agregando el servicio…',
  groundCaptureError: 'No pudimos agregarlo. Volvé a buscar y elegí la opción nuevamente.',
  groundSearchExpired: 'Este resultado ya no tiene una captura disponible. Actualizá la búsqueda y volvé a elegirlo.',
  groundPartyMismatch:
    'Revisá los viajeros de este servicio: deben coincidir con la cantidad y edades de la búsqueda. Podés elegir un grupo o ajustar la ocupación.',
  groundLargeParty: 'Podés buscar para un grupo del viaje y asignarle sus viajeros al agregar el servicio.',
  groundUnavailable:
    'Este buscador no está habilitado para la agencia del caso. Podés agregar el servicio manualmente.',
  groundPriceFrom:
    'Precio desde, sin total para el grupo. Podés fijar la venta; se revisará al consultar disponibilidad.',
  groundCommissionUnknown:
    'El proveedor no informó una comisión conciliable. La venta sugerida conserva el precio recibido y el costo queda pendiente.',
  groundCostUnknown: 'Modelo de costo pendiente. No se calcula ganancia hasta confirmar el costo.',
  groundIndicative: 'Precio indicativo de búsqueda. Puede cambiar al comprobar disponibilidad o incorporar impuestos.',
  groundPaidAtDestination:
    'El importe del proveedor se paga en destino. La venta de la agencia comienza en cero; podés ajustar su cargo comercial.',
  groundAgencyBaseUnknown:
    'Hay cargos en destino y falta el importe que cobra la agencia. Revisá la venta antes de publicar.',
  groundConditionsUnknown: 'Condiciones de pago o cancelación no informadas completamente.',
  groundExpired: 'La oferta temporal venció. El precio guardado se conserva como referencia para recotizar.',
  groundCaptured: 'Precio consultado el',
  groundConditions: 'Ver detalles y condiciones',
  groundReferencePrice: 'Referencia desde',
  groundDays: 'días',
  groundEsimUnit: '1 paquete para 1 dispositivo. El importe se reparte entre los viajeros asignados; no incluye una eSIM por viajero.',
  groundLuggage: 'Equipaje',
  searchFlights: 'Buscar vuelos',
  addFlightOption: 'Agregar a la propuesta',
  addFlightAlternative: 'Otra opción de vuelo',
  flightAdded: 'Vuelo agregado. Podés elegir otra alternativa.',
  flightCaptureError: 'No pudimos agregar el vuelo. Revisá los viajeros y volvé a intentar.',
  flightCapturing: 'Agregando vuelo…',
  flightAssign: 'Viajeros de este vuelo',
  flightAssignHint:
    'Elegí quiénes viajan. Podés agregar habitaciones o viajeros acá mismo; no necesitás nombres ni documentos.',
  flightAutoAssign: 'Asignar por tipo de pasajero',
  tripChangeDates: 'Cambiar fechas',
  tripSuggestions: 'Usar los datos del viaje',
  tripUse: '{{destination}} · {{from}}{{to}}',
  customerServiceName: 'Editar nombre para el cliente',
  transferShortTitle: 'Traslado',
  transferRoundTripTitle: 'Traslados de ida y vuelta',
  transferArrivalTitle: 'Traslado de llegada',
  transferDepartureTitle: 'Traslado de salida',
  transferRouteTitle: 'Traslado {{from}} → {{to}}',
  flightCustomerTerms: 'Editar condiciones para el cliente',
  flightCustomerTermsHint: 'Estas son las condiciones comerciales de la propuesta. Si el proveedor no informa reembolso, se ofrece sin reembolso por defecto. Podés ajustarlo acá sin cambiar la información original.',
  flightCustomerChanges: 'Cambios ofrecidos al cliente',
  flightCustomerRefund: 'Reembolso ofrecido al cliente',
  flightUseSource: 'Usar información del proveedor',
  flightCustomerBaggage: 'Equipaje para el cliente',
  flightCustomerBaggageHint: 'Completá solo información confirmada; indicá el tramo si cambia entre vuelos. Vacío: se muestra el equipaje informado por el motor.',
  flightSourceNotes: 'Detalle de tarifa y reparto',
  flightCommercialAllocation:
    'El proveedor no informó un desglose por pasajero que concilie con el total. Se usa un reparto comercial en partes iguales.',
  flightExpired: 'El precio proviene de una oferta vencida. Volvé a buscar antes de avanzar con la reserva.',
  flightConditionsUnknown: 'Hay condiciones que el resultado de búsqueda no informa. Se revisarán antes de reservar.',
  flightOccupancyChanged: 'Los viajeros cambiaron respecto de esta oferta. Volvé a buscar para actualizarla.',
  flightRefund: 'Reembolso',
  flightChanges: 'Cambios',
  flightAllowed: 'Permitido según condiciones',
  flightNotAllowed: 'No permitido',
  flightPenalty: 'Penalidad informada',
  flightGroupBy: 'Precios agrupados por',
  flightUngrouped: 'Sin grupo',
  flightMixedPrices:
    'Este grupo tiene criterios de venta diferentes. Solo se reemplazan si aplicás un nuevo precio al grupo.',
  flightGroupHint:
    'Los importes son el total de cada grupo y tipo de pasajero. El reparto se actualiza automáticamente.',
  flightApplyGroup: 'Aplicar precio al grupo',

  searchHotels: 'Buscar hoteles',
  searchHotelAlternative: 'Buscar alternativa de hotel',
  addHotelOption: 'Agregar a la propuesta',
  backToQuote: 'Volver a la propuesta',
  hotelAdded: 'Opción agregada. Podés seguir eligiendo alternativas.',
  hotelCaptureError: 'No pudimos agregar la opción. Reintentá o elegí otra oferta.',
  hotelCapturing: 'Agregando hotel…',
  hotelAssignRooms: 'Asignar habitaciones',
  hotelAssignHint: 'Relacioná la búsqueda con las habitaciones del viaje o creá nuevas sin nombres ni documentos.',
  hotelNewRoom: 'Crear habitación y grupo con estos viajeros',
  hotelOccupancy: 'Habitación {{number}} · {{adults}} adultos · edades de menores: {{ages}}',
  sourceCostHint:
    'Costo y condiciones conservan la búsqueda original. Podés ajustar la venta y el reparto; para cambiar fechas, buscá una nueva opción.',
  hotelImageMissing: 'Sin foto disponible',
  hotelLocation: 'Ver ubicación',
  hotelLocationMissing: 'Ubicación no informada',
  hotelBoardMissing: 'Régimen pendiente',
  hotelCaptured: 'Precio de búsqueda del',
  hotelOccupancyChanged:
    'Cambió la ocupación. Este precio conserva la búsqueda anterior; volvé a buscar para actualizarlo.',
  hotelChargesReview: 'Cargos a revisar',
  hotelConditions: 'Ver información y condiciones',
  hotelBinding: 'Precio vinculante informado',
  hotelMinimum: 'Venta mínima informada',
  hotelRoomAllocation: 'El proveedor informó un total: el desglose por habitación es un reparto comercial.',
  yes: 'Sí',
  no: 'No',
  hotelIssues: {
    occupancy_incomplete: 'La oferta no detalla todas las habitaciones solicitadas. Su costo queda pendiente.',
    cost_basis_unknown:
      'El proveedor no identifica un costo neto. Revisá la oferta o agregá un servicio manual con el costo confirmado.',
    charges_incomplete: 'Puede haber cargos adicionales no detallados; revisar antes de reservar.',
    payment_pending: 'Seña y vencimientos pendientes de condiciones confirmadas.',
  },

  backgroundError: 'No pudimos actualizar la versión guardada. Tu edición sigue aquí.',
  accessRefreshError:
    'No pudimos confirmar el acceso al cotizador. Conservamos tu edición; reintentá antes de guardar.',
  invalidRoom: 'Revisá el nombre, la cantidad de adultos y las edades de menores (0 a 17). Máximo 100 viajeros.',
  rowTotals: 'Importes totales de esta fila, para sus participantes.',
  createError: 'No pudimos confirmar la creación. Reintentá para recuperar la misma propuesta.',
  moveUp: 'Subir bloque',
  moveDown: 'Bajar bloque',
  discardLocal: '¿Descartar tu edición local y cargar la versión guardada?',
  saveAndLeave: 'Guardar y salir',
  currencyChange:
    'Se convertirán las ventas fijas, repartos, descuentos y seña con el cambio indicado. Los costos conservan su moneda. Reingresá después los otros tipos de cambio respecto a la nueva moneda.',
  addPriceRow: 'Agregar fila de precio (ADT / CHD / INF)',
  title: 'Cotizaciones',
  subtitle: 'Armá el viaje, compará opciones y ajustá la propuesta.',
  open: 'Ver cotizaciones',
  newQuote: 'Nueva propuesta',
  empty: 'Todavía no hay cotizaciones en este caso.',
  create: 'Crear propuesta',
  back: 'Volver',
  close: 'Cerrar',
  retry: 'Reintentar',
  loading: 'Cargando…',
  saved: 'Guardado',
  dirty: 'Cambios pendientes',
  saving: 'Guardando…',
  error: 'No pudimos guardar. Tu edición sigue aquí.',
  conflict: 'Otro asesor guardó cambios. Conservamos tu edición para que elijas cómo continuar.',
  saveCopy: 'Guardar mi edición como otra propuesta',
  loadRemote: 'Cargar versión actual',
  unsaved: 'Hay cambios sin guardar',
  unsavedDetail: 'Podés seguir editando o cerrar y descartar estos cambios.',
  keepEditing: 'Seguir editando',
  discard: 'Cerrar sin guardar',
  loadError: 'No pudimos cargar esta información.',
  case: 'Caso #{{id}}',
  proposalTitle: 'Nombre de la propuesta',
  updated: 'Actualizada {{date}}',
  privateDraft: 'Borrador interno',
  previewOnly: 'Todavía no se ha publicado esta propuesta.',
  travelers: 'Viajeros y habitaciones',
  traveler: 'Viajero {{number}}',
  adult: 'Adulto {{number}}',
  minor: 'Menor {{number}}',
  travelerCount: '{{count}} viajeros',
  adults: 'Adultos',
  minorAges: 'Edades de menores',
  agesHint: 'Una edad por menor: por ejemplo, 8, 12.',
  invalidAges: 'Indicá edades enteras entre 0 y 17.',
  age: 'Edad',
  addRoom: 'Agregar habitación',
  roomName: 'Nombre de la habitación',
  roomNumber: 'Habitación {{number}}',
  family: 'Familia / grupo',
  newFamily: 'Nueva familia / grupo',
  familyName: 'Nombre del grupo',
  familyNumber: 'Familia {{number}}',
  rooms: 'Habitaciones',
  families: 'Familias',
  noRoom: 'Sin habitación',
  noFamily: 'Sin familia',
  noTravelers: 'Agregá las habitaciones o empezá por los servicios. No necesitás nombres ni documentos.',
  removeTraveler: 'Quitar viajero',
  removeTravelerDetail:
    'Se conserva el precio de los servicios. Se actualizará el reparto de los servicios afectados; revisalo después de quitar al viajero.',
  remove: 'Quitar',
  cancel: 'Cancelar',
  add: 'Agregar',
  apply: 'Aplicar',
  confirm: 'Confirmar',
  name: 'Nombre',
  servicesTitle: 'Servicios del viaje',
  sharedServices: 'Servicios compartidos',
  reviewPending: 'Revisar',
  pricingIssue: {
    selection_missing: 'Elegí una opción para este servicio.',
    components_missing: 'Esta opción todavía no tiene servicios.',
    exchange_rate_missing: 'Falta el tipo de cambio del costo.',
    cost_unknown: 'Falta confirmar el costo.',
    sale_unknown: 'Falta definir el precio de venta.',
    participants_missing: 'Falta indicar quiénes participan.',
    discount_pending: 'Hay un descuento pendiente de calcular.',
    deposit_pending: 'Falta definir la seña.',
    balance_date_pending: 'Falta la fecha prevista del saldo.',
    payment_dates_inverted: 'La fecha del saldo no puede ser anterior a la seña.',
  },
  addServiceMenu: 'Agregar servicio',
  moreActions: 'Más acciones',
  searchNotEnabled: 'Buscador no habilitado',
  manualSearchHint: 'Podés cargar cualquier servicio manualmente, aunque su buscador no esté habilitado.',
  backToLibrary: 'Volver a biblioteca',
  libraryChooseHotel: 'Elegir como hotel preferido',
  addService: 'Agregar servicio manual',
  editService: 'Editar servicio',
  serviceTitle: 'Nombre del servicio',
  serviceType: 'Tipo de servicio',
  description: 'Descripción para la propuesta',
  startDate: 'Desde',
  endDate: 'Hasta',
  participants: 'Participantes',
  allTravelers: 'Todos los viajeros',
  addAlternative: 'Agregar alternativa',
  addComponent: 'Agregar servicio a esta opción',
  optionTitle: 'Nombre de la opción',
  chosen: 'Elegida',
  choose: 'Elegir',
  optional: 'Opcional',
  included: 'Incluido',
  include: 'Incluir en el viaje',
  emptyServices: 'Sumá el primer servicio. Podés ofrecer varias alternativas y combinarlas por bloques.',
  alternative: 'Opción {{number}}',
  edit: 'Editar',
  deleteOption: 'Quitar opción',
  deleteBlock: 'Quitar bloque',
  blockName: 'Nombre del bloque',
  deleteConfirm: '¿Quitar este elemento de la propuesta?',
  cost: 'Costo',
  sale: 'Venta',
  margin: 'Margen sobre venta (%)',
  pricing: 'Precio y margen',
  fixedSale: 'Precio de venta',
  useMargin: 'Calcular por margen',
  useDefault: 'Usar margen de la propuesta',
  net: 'Neto',
  commissionable: 'PVP comisionable',
  pvp: 'PVP',
  commission: 'Comisión',
  currency: 'Moneda',
  pending: 'A confirmar',
  unknownCost: 'Podés dejar el costo pendiente y fijar una venta.',
  invalidMoney: 'Revisá el importe y los decimales de la moneda.',
  invalidForm: 'Revisá los datos de este servicio.',
  invalidMargin: 'El margen debe ser menor al 100%.',
  invalidCommission: 'La comisión no puede superar el PVP.',
  advanced: 'Detalle de precios y condiciones',
  splitRooms: 'Precio por habitación',
  splitFamilies: 'Precio por familia',
  priceRow: 'Grupo {{number}}',
  fareType: 'Tipo de tarifa',
  unclassified: 'Sin clasificar',
  allocation: 'Reparto comercial',
  equalSplit: 'Por partes iguales',
  weightedSplit: 'Por pesos / porcentajes',
  amountSplit: 'Por importes',
  weight: 'Peso relativo',
  amount: 'Importe',
  allocationHint: 'Un peso 0 excluye del reparto sin quitar al viajero del servicio.',
  payments: 'Condiciones de seña y saldo',
  refundable: 'Reembolsable',
  nonrefundable: 'Exigible completo / no reembolsable',
  conditionsUnknown: 'Condiciones a confirmar',
  supplierDue: 'Vencimiento del proveedor',
  penaltyDate: 'Entrada en gastos',
  commitment: 'Costo exigible ahora',
  destinationCharges: 'Cargos a pagar en destino',
  addCharge: 'Agregar cargo',
  summary: 'Resumen del viaje',
  total: 'Total de la selección',
  profit: 'Ganancia',
  deposit: 'Seña prevista',
  balance: 'Saldo previsto',
  priceSettings: 'Ajustar precios y condiciones',
  loss: 'Hay servicios por debajo del costo. Revisá el detalle antes de publicar.',
  incomplete: 'Hay precios o condiciones pendientes de completar.',
  previewError: 'Revisá los precios y repartos para calcular el resumen.',
  recalculating: 'Actualizando importes…',
  details: 'Ver detalle',
  defaultMargin: 'Margen sugerido (%)',
  exchangeRates: 'Tipos de cambio comerciales',
  rate: 'Cambio a moneda de venta',
  addRate: 'Agregar cambio',
  discounts: 'Descuentos',
  addDiscount: 'Agregar descuento',
  scope: 'Aplicar a',
  proposal: 'Toda la propuesta',
  option: 'Opción',
  percent: 'Porcentaje (%)',
  pendingDeposit: 'Pendiente de definir',
  automatic: 'Automática según servicios',
  fixedDeposit: 'Importe fijo',
  percentDeposit: 'Porcentaje de venta',
  depositDate: 'Fecha de seña',
  balanceDate: 'Fecha de saldo (ajuste manual)',
  penaltyLead: 'Días antes de entrada en gastos',
  tripLead: 'Días antes del viaje',
  settingsHelp: 'Los cobros se gestionan en la orden de venta. Aquí definís las condiciones ofrecidas.',
  removeSplit: 'Volver a reparto igualitario',
  columns: { group: 'Grupo', total: 'Venta', cost: 'Costo', deposit: 'Seña', balance: 'Saldo' },
  services: {
    flight: 'Vuelo',
    hotel: 'Hotel',
    transfer: 'Traslado',
    activity: 'Actividad',
    ferry: 'Ferry',
    train: 'Tren',
    bus: 'Bus',
    car: 'Auto',
    esim: 'eSIM',
    pass: 'Pase',
    circuit: 'Circuito',
    insurance: 'Seguro',
    other: 'Otro servicio',
  },
};

export const commercialQuotesEn: typeof commercialQuotesEs = {
  customerText: { introduction: 'Introduction for your customer', recommendation: 'Why we recommend this option', hint: 'Optional. This text will appear in the link and PDF. Leave it empty to remove it.', cancel: 'Cancel', save: 'Save text', advisor: 'Your advisor', includes: 'Your trip includes', why: 'Why we recommend it' },
  presentation: {"title": "Quote presentation", "hint": "All fields are optional. Changes apply to new publications; sent versions retain their information.", "identity": "Agency logo and details", "readOnly": "Only an administrator can edit these details.", "hours": "Opening hours", "registration": "Agency registration", "paymentMethods": "Payment methods (information only)", "terms": "General quote terms", "branches": "Branches", "branchname": "Branch name", "branchaddress": "Address", "branchmapUrl": "Location link (https://\u2026)", "removeBranch": "Remove branch", "addBranch": "Add branch", "preview": "Public information preview", "loadError": "Could not load settings.", "saveError": "Could not save. Check the fields and location links and retry; your changes are still here.", "saved": "Settings saved.", "save": "Save presentation", "saving": "Saving\u2026"},
  booking: {
    previous: 'Previous', next: 'Next',
    partyChanged: 'Ages or party composition changed. Open search to update this option with current traveler details.',
    caseClientRequired: 'Link a customer to the case before requesting a booking from an engine. You can continue preparing the trip and recording external bookings.',
    title: 'Prepare bookings', loading: 'Loading…', intro: 'Review the services and open each booking with its details prefilled. The engines check current costs and terms before booking. The commercial selling price remains unchanged; payments are managed in Power.',
    selectionHint: 'The customer selection applies to options that still exist. Review current services and terms before booking: the selection does not accept later changes or create reservations.',
    selectionChanged: 'A selected option changed or was removed. Review the selection and choose its replacement in the draft.', applySelection: 'Use selection and prepare bookings',
    prepareFailed: 'We could not prepare this service. Check that the draft is saved, review traveler profiles or open search to update the option. You can also record an external booking.',
    profiles: 'Case travelers', profilesHint: 'Assign each trip participant to their profile. Complete personal details once in the case; each service requests only what it needs.',
    adult: 'Adult {{number}}', minor: 'Child {{number}} · age {{age}}', unassigned: 'Assign later', manageProfiles: 'Complete case profiles',
    commercialPrice: 'Agreed selling price', quotedCost: 'Quoted cost', toConfirm: 'To confirm', prepare: 'Review and book', search: 'Find another option', manual: 'Record external booking',
    manualHint: 'Record a booking managed outside these engines, including its provider and actual status. Saving this record does not request or cancel a reservation.',
    manualError: 'We could not confirm the save. Retrying uses the same record; you can also close and check history before continuing.',
    provider: 'Provider', reference: 'Booking reference', status: 'Actual status', note: 'Internal note', saveManual: 'Save record', retry: 'Retry', close: 'Close',
    history: 'Quote bookings',
    fromQuote: 'Origin: quotes', historyHint: 'Manage each booking from the case under its current terms, even if the quote is archived. Cancellation and a replacement booking are separate actions.',
    historyTruncated: 'Showing the most recent bookings.', noBookings: 'No bookings recorded yet.', loadFailed: 'We could not load bookings. Refresh to retry.',
    verifyFirst: 'An attempt needs verification. Open it to check or reconcile the outcome before booking this service again.', manage: 'Open booking / continue', editManual: 'Update record', refresh: 'Refresh', chooseServices: 'Choose trip options to prepare their bookings.',
    states: { pending: 'Pending', draft: 'Pending', quoting: 'Checking fare', quoted: 'Fare ready', booking: 'In progress', booked: 'Confirmed', confirmed: 'Confirmed', held: 'Held', uncertain: 'Needs verification', unknown: 'Needs verification', rejected: 'Rejected', failed: 'Booking failed', unavailable: 'Unavailable', expired: 'Expired', discarded: 'Discarded', cancelled: 'Cancelled' },
  },

  review: {
    belowCost: 'Keeping the current sale puts this service below cost.',
    title: 'Refresh availability and prices',
    hint: 'We search without booking. The customer keeps the published proposal. Applying a result only updates the draft.',
    running: 'Searching',
    completed: 'Review ready',
    interrupted: 'Review interrupted',
    refresh: 'Review every option',
    error: 'Could not finish. Retry or open search; this does not mean the service is sold out.',
    stale:
      'The draft changed. Only results whose service and participants are unchanged can be applied; refresh again if needed.',
    pending: 'Pending',
    available: 'Matching option found',
    alternatives: 'Alternatives to review',
    not_found: 'Not found in this search',
    unverified: 'Unverified',
    manual: 'Manual handling',
    changed: 'Service updated',
    unknown: 'To confirm',
    cost: 'Cost',
    sale: 'Proposed sale',
    mapping: 'Open search to check expiry and assign participants.',
    captured: 'Searched',
    expired: 'Previous search price: refresh before booking.',
    searchOnly: 'Search price; this is not a booking.',
    partial: 'Partial response. Providers that did not respond remain unverified.',
    same: 'Same service and terms detected; review the amounts.',
    material: 'Details or terms changed. If they affect the sale, publish the update and agree it with the customer.',
    adopt: 'Use and keep my pricing method',
    absorb: 'Use and keep sale and deposit',
    search: 'Open full search',
    manualAction: 'Handle manually',
    close: 'Back to quotation',
  },
  pdf: {
    download: 'Download my selection as PDF',
    preparing: 'Preparing PDF…',
    failed: 'Could not prepare the PDF. Retry shortly or contact the agency.',
  },
  selection: {
    title: 'Client selections',
    advance: 'Send my selection on WhatsApp',
    save: 'Share my selection',
    saving: 'Saving selection…',
    consult: 'Ask on WhatsApp',
    call: 'Contact the agency',
    open: 'Open WhatsApp',
    saved: 'Your selection has been saved with the agency.',
    sendHint: 'Send the message in WhatsApp to talk to your advisor. This does not book any services yet.',
    contactHint: 'Your advisor can now see your selection. Contact the agency to continue.',
    failed: 'We could not confirm the save. You can retry or ask on WhatsApp.',
    oldVersion:
      'We saved your selection for this version. A newer proposal is available; review it or ask your advisor.',
    latest: 'View update',
    inquiryMessage: 'Hi, I have a question about “{{title}}” (version {{version}}). Reference {{reference}}.',
    selectionMessage:
      'Hi, I would like to continue with my selection for “{{title}}” (version {{version}}). Reference {{reference}}. Please confirm availability and conditions.',
    statusHint: 'A saved selection does not mean the client sent a message or requested a booking.',
    loading: 'Loading selections…',
    retry: 'Retry',
    loadFailed: 'Could not load selections.',
    empty: 'No selections have been saved yet.',
    received: 'Message received',
    savedOnly: 'Selection saved',
    previousVersion: 'Previous version',
    excluded: 'Not included',
    toConfirm: 'To be confirmed',
    refresh: 'Refresh',
    close: 'Close',
  },
  publication: {
    title: 'Publish and share',
    snapshot: 'Publishing freezes a version. Draft changes do not change the link until you publish again.',
    linkFailed: 'The version was published, but the link could not be created. Use Create public link to retry.',
    failed: 'Could not complete the action. Check saved changes, prices and case access, then retry.',
    archived: 'This proposal is archived. The client can read it and contact the agency.',
    pricingInvalid: 'Review discounts and allocations in Pricing before publishing.',
    belowCost: 'I confirm publishing this sale below its known cost.',
    publish: 'Publish new version',
    copyNow: 'Link created. Copy it now; its plain value is not stored.',
    open: 'Open client view',
    copy: 'Copy link',
    copyFailed: 'Could not copy. Open the client view and copy its address.',
    linkActive: 'The current link is active and displays the latest published version.',
    linkOff: 'Public access is disabled.',
    rotate: 'Create a new link and invalidate the previous one',
    createLink: 'Create public link',
    revoke: 'Disable link',
    rotateHint:
      'Creating another link invalidates the previous one. Publishing another version keeps the existing link.',
    restore: 'Restore proposal',
    archive: 'Archive proposal',
    history: 'Published versions',
    revision: 'Draft',
    close: 'Close',
  },
  publicView: {
    chooseOption: 'Choose this option', viewHotelPhoto: 'View hotel photo', closePhoto: 'Close', directFlight: 'Nonstop flight', stopCount_one: '{{count}} stop', stopCount_other: '{{count}} stops', baggageUnknown: 'Confirm baggage with your advisor', bagWeight: 'up to {{weight}} kg per piece',
    bags: { CHECKED: {general: 'Checked baggage included', none: 'Checked bag not included', included_one: '{{count}} checked bag included', included_other: '{{count}} checked bags included'}, CARRY_ON: {general: 'Cabin baggage included', none: 'Cabin bag not included', included_one: '{{count}} cabin bag included', included_other: '{{count}} cabin bags included'}, PERSONAL_ITEM: {general: 'Personal item included', none: 'Personal item not included', included_one: '{{count}} personal item included', included_other: '{{count}} personal items included'} },

    showSummary: 'View breakdown and payment terms',
    hideSummary: 'Hide breakdown',
    noPhoto: 'Photo unavailable',
    map: 'View location',
    stops: 'stops',
    operated: 'Operated by',
    terminal: 'Terminal',
    connection: 'Connection',
    customerTerms: 'Terms of this proposal',
    refund: 'Refund',
    changes: 'Changes',
    unknown: 'To be confirmed',
    allowed: 'Allowed',
    notAllowed: 'Not allowed',
    refundPenalty: 'Refund charge',
    changePenalty: 'Change charge',
    separateTickets: 'This itinerary combines separate tickets.',
    itinerary: 'View daily itinerary',
    day: 'Day',
    includes: 'Included',
    conditions: 'View conditions',
    optional: 'Optional',
    included: 'Included',
    withoutOptional: 'Do not include this service',
    chosen: 'Selected',
    calculating: 'Calculating\u2026',
    toConfirm: 'To be confirmed',
    samePrice: 'No price difference',
    forGroup: 'for the group',
    retry: 'Retry',
    calculationFailed: 'Could not update the amount. Retry or contact the agency.',
    loading: 'Loading proposal',
    unavailable: 'Could not open this proposal. The link may have changed or been disabled; contact your advisor.',
    contact: 'Ask us',
    yourTrip: 'Your travel proposal',
    travelers: 'travelers',
    published: 'Published',
    searchOnly: 'Search prices are subject to reconfirmation. This proposal is not a booking.',
    archived: 'Archived proposal. You can read its contents and contact the agency.',
    seeLatest: 'View update',
    updated: 'A newer version is available. Your current choices belong to the previous version.',
    summary: 'Your trip',
    groupTotal: 'Group total with selected options',
    families: 'By family or group',
    rooms: 'View by room',
    passengerTypes: 'View ADT / CHD / INF',
    travelGroup: 'Travel group',
    otherTravelers: 'Other travelers',
    sharedServices: 'Shared services',
    unassigned: 'No assigned group',
    deposit: 'Expected deposit',
    balance: 'Expected balance',
    dateToConfirm: 'Date to be confirmed',
    paymentHint: 'These are proposed conditions, not records of payments.',
    atDestination: 'Pay directly at destination',
    agencyWebsite: 'Agency website',
    baggage: { CHECKED: 'Checked baggage', CARRY_ON: 'Carry-on baggage', PERSONAL_ITEM: 'Personal item' },
  },
  libraryTransferLinkHint:
    'The transfer can follow the hotel or flight selected in the proposal. If that selection or location is missing, complete the point in search.',
  libraryOriginLink: 'Transfer origin',
  libraryDestinationLink: 'Transfer destination',
  libraryFixedPoint: 'Saved place / complete in search',
  libraryMissingLink: 'Reference removed: choose another or an independent place',
  libraryLinks: { hotel: 'Selected hotel', 'flight-arrival': 'Flight arrival', 'flight-departure': 'Flight departure' },

  libraryTravelerPositions: 'Traveler positions (1,2,...)',
  library: 'Library',
  libraryTemplates: 'Trip templates',
  libraryHotels: 'Preferred and favorite hotels',
  libraryFind: 'Search by name or destination',
  libraryArchived: 'Archived',
  libraryCreate: 'Create template',
  librarySaveDraft: 'Save this proposal as a template',
  libraryHotelHint:
    'Favorites are personal. Shared preferences belong to the agency. Commercial category is separate from stars.',
  libraryFindHotel: 'Find a hotel to save',
  librarySaveHotel: 'Save hotel',
  libraryLoadError: 'Could not load the library. Retry or continue working.',
  libraryEmpty: 'No items match these filters yet.',
  libraryShared: 'Agency',
  libraryPersonal: 'Personal',
  libraryRank: 'Order (lowest first)',
  libraryUse: 'Use template',
  libraryCopy: 'Create personal copy',
  libraryRestore: 'Restore',
  libraryArchive: 'Archive',
  libraryPrevious: 'Previous',
  libraryNext: 'Next',
  libraryReview: 'Review reusable structure',
  libraryVisibility: 'Visibility',
  librarySave: 'Save',
  libraryUseHint:
    'Services will be added to this proposal using its current travelers. Choose arrival date, then search current prices for each service.',
  libraryUseCircuitHint:
    'Choose an approximate search date. Select a real circuit departure to calculate stays and services before and after it.',
  librarySearchDate: 'Approximate departure date',
  libraryArrival: 'Arrival at first destination',
  libraryCommercialCategory: 'Commercial category',
  libraryCategory: { premium: 'Premium', value: 'Value', economy: 'Economy' },
  libraryRecipeHint:
    'We save needs, relative dates and options. Review relative groups: travelers, prices, fare conditions and required providers are not copied. Day 0 is the reference date.',
  libraryAnchor: 'Date reference',
  libraryCircuitAnchor: 'Actual circuit departure',
  libraryOrigin: 'Origin / pickup point',
  libraryDestination: 'Destination',
  libraryDay: 'Relative day (0 = reference)',
  libraryNights: 'Nights / duration in days',
  libraryParticipants: 'Relative participants',
  libraryGroup: { all: 'All travelers', room: 'Room', family: 'Family', travelers: 'Travelers by position' },
  libraryGroupNumber: 'Group number',
  libraryInstructions: 'Requirement description',
  libraryAddBlock: 'Add block',
  librarySaveError:
    'Could not save. Check the fields; if another advisor changed this item, close and reopen it to use its current version.',
  libraryInvalidDate: 'Choose a valid date.',
  libraryMissingGroup: 'A template room or family is missing. Complete the case groups or adjust a template copy.',
  libraryTooLarge: 'This proposal exceeds the 100-block limit.',
  libraryPending: 'Pending quotation.',
  librarySearchService: 'Search service',
  libraryPartyLocked: 'This search uses the service group. Return to the proposal to change its travelers.',
  libraryQuickHotels: 'Quick access to preferred and favorite hotels',
  libraryAllHotels: 'Search all hotels',
  libraryAvailabilityHint:
    'Each hotel is searched for current dates and rooms. If unavailable, all results remain accessible.',

  internalNote: 'Internal advisor reference',
  circuitReferencePrice:
    'Per-person or indicative price. Set the commercial sale; the occupancy total is checked before booking.',
  circuitItineraryMissing: 'The provider did not return a complete itinerary. You can complete the description.',
  circuitPlan: 'Plan travel around this circuit',
  circuitFixedDates:
    'The circuit departure stays fixed. Additional nights are separate services; included hotels and transfers are not added again.',
  circuitChooseDeparture: 'Select a dated departure to plan travel.',
  preNights: 'Nights before circuit',
  postNights: 'Nights after circuit',
  circuitTravelDates: 'Destination arrival: {{arrival}} · Departure: {{departure}}',
  circuitLinkDates: 'Link dates to a circuit',
  circuitIndependentDates: 'Independent dates',
  circuitDatesChanged: 'Review this option for the planned dates: {{dates}}. Original price and dates are preserved.',
  circuitSearchAgain: 'Search another option',
  circuitUseFlightArrival: 'Adjust nights to arrival on {{date}}',
  circuitFlightArrivalHint:
    'The flight should arrive on {{date}}. Choose departure accounting for travel time and day changes. Planned return: {{end}}.',
  circuitFlightReturnHint: 'Planned return departure: {{date}}.',
  circuitExtraReference:
    'Catalogue reference. Review participants, conditions and total price before adding. No reservation is requested.',
  circuitAddExtra: 'Prepare extra',
  circuitAddOptional: 'Offer as optional',
  circuitItinerary: 'View daily itinerary',
  circuitIncluded: 'Included in the circuit',
  circuitDay: 'Day {{day}}',
  circuitCategories: 'Categories and planned hotels',
  circuitCategoriesHint:
    'The selected category belongs to the captured departure. To change it, add another search alternative.',
  circuitOccupancyRange: 'Occupancy: {{min}}–{{max}} per room',
  circuitExtras: 'Supplements and optional excursions',
  circuitAgeRange: 'Ages {{from}}–{{to}}',
  circuitMaxNights: 'Maximum nights: {{count}}',
  circuitAdvanceDays: 'Minimum advance days: {{count}}',
  circuitTransferDetails: 'Transfer details required',
  circuitAfterBooking: 'Available after booking',
  circuitAtBooking: 'Available when booking',
  circuitRoles: {
    'pre-hotel': 'Hotel before',
    'post-hotel': 'Hotel after',
    'arrival-transfer': 'Arrival transfer',
    'departure-transfer': 'Departure transfer',
    'outbound-flight': 'Outbound flight',
    'return-flight': 'Return flight',
    'roundtrip-flight': 'Return flights',
  },
  circuitUnits: {
    passenger: 'Per passenger',
    room: 'Per room',
    booking: 'Per booking',
    night: 'Per night',
  },
  searchGround: 'Search other services',
  addGroundOption: 'Add to proposal',
  insuranceAgeBasedPrice: 'Price based on searched ages. Adults with no known age are estimated at 30; actual ages are checked before booking.',
  groundAlternative: 'Another service option',
  groundAdded: 'Service added. You can keep choosing alternatives.',
  groundCapturing: 'Adding the service…',
  groundCaptureError: 'We could not add this service. Refresh the search and select it again.',
  groundSearchExpired: 'This result is no longer available for capture. Refresh the search and select it again.',
  groundPartyMismatch:
    'Check the travelers for this service against the search count and ages. Select a group or update the party.',
  groundLargeParty: 'You can search for part of the trip party and assign its travelers when adding the service.',
  groundUnavailable: 'This search is not enabled for the case agency. You can add the service manually.',
  groundPriceFrom: 'Starting price, without a group total. You can set the sale price and check availability later.',
  groundCommissionUnknown:
    'The supplier did not provide a reconcilable commission. The suggested sale preserves the reported price; cost remains unknown.',
  groundCostUnknown: 'Cost model pending. Profit is not calculated until cost is confirmed.',
  groundIndicative: 'Indicative search price. Availability checks or taxes may change it.',
  groundPaidAtDestination:
    'The supplier amount is paid at destination. Agency sale starts at zero; you can adjust its commercial charge.',
  groundAgencyBaseUnknown:
    'There are destination charges but no agency collection amount. Review the sale before publishing.',
  groundConditionsUnknown: 'Payment or cancellation terms are not fully reported.',
  groundExpired: 'The temporary offer expired. Its saved price remains a reference for repricing.',
  groundCaptured: 'Price checked on',
  groundConditions: 'View details and conditions',
  groundReferencePrice: 'Starting price reference',
  groundDays: 'days',
  groundEsimUnit: '1 package for 1 device. The amount is shared by the assigned travelers; it does not include one eSIM per traveler.',
  groundLuggage: 'Luggage',
  searchFlights: 'Search flights',
  addFlightOption: 'Add to proposal',
  addFlightAlternative: 'Another flight option',
  flightAdded: 'Flight added. You can choose another alternative.',
  flightCaptureError: 'Could not add the flight. Check travelers and try again.',
  flightCapturing: 'Adding flight…',
  flightAssign: 'Travelers on this flight',
  flightAssignHint: 'Choose who travels. Add rooms or travelers here; names and documents are not required.',
  flightAutoAssign: 'Assign by passenger type',
  tripChangeDates: 'Change dates',
  tripSuggestions: 'Use trip details',
  tripUse: '{{destination}} · {{from}}{{to}}',
  customerServiceName: 'Edit customer-facing name',
  transferShortTitle: 'Transfer',
  transferRoundTripTitle: 'Round-trip transfers',
  transferArrivalTitle: 'Arrival transfer',
  transferDepartureTitle: 'Departure transfer',
  transferRouteTitle: 'Transfer {{from}} → {{to}}',
  flightCustomerTerms: 'Edit customer terms',
  flightCustomerTermsHint: 'These are the proposal’s commercial terms. When the supplier does not report refundability, new proposals default to non-refundable. You can adjust this without changing the original evidence.',
  flightCustomerChanges: 'Changes offered to the customer',
  flightCustomerRefund: 'Refund offered to the customer',
  flightUseSource: 'Use supplier information',
  flightCustomerBaggage: 'Customer baggage details',
  flightCustomerBaggageHint: 'Enter confirmed information only; identify the leg if it varies. Leave blank to use baggage reported by the search engine.',
  flightSourceNotes: 'Fare details and allocation',
  flightCommercialAllocation:
    'The provider did not supply a passenger breakdown matching the total. An equal commercial split is used.',
  flightExpired: 'This price comes from an expired offer. Search again before booking.',
  flightConditionsUnknown: 'Some conditions were not supplied by the search result. Review them before booking.',
  flightOccupancyChanged: 'Travelers changed since this offer was captured. Search again to update it.',
  flightRefund: 'Refund',
  flightChanges: 'Changes',
  flightAllowed: 'Allowed subject to conditions',
  flightNotAllowed: 'Not allowed',
  flightPenalty: 'Reported penalty',
  flightGroupBy: 'Group prices by',
  flightUngrouped: 'Ungrouped',
  flightMixedPrices: 'This group has different sale settings. They are replaced only when you apply a new group price.',
  flightGroupHint: 'Amounts are totals for each group and passenger type. Allocation updates automatically.',
  flightApplyGroup: 'Apply group price',

  searchHotels: 'Search hotels',
  searchHotelAlternative: 'Search hotel alternative',
  addHotelOption: 'Add to proposal',
  backToQuote: 'Back to proposal',
  hotelAdded: 'Option added. You can keep selecting alternatives.',
  hotelCaptureError: 'Could not add this option. Retry or choose another offer.',
  hotelCapturing: 'Adding hotel…',
  hotelAssignRooms: 'Assign rooms',
  hotelAssignHint: 'Match search rooms to this trip or create anonymous rooms.',
  hotelNewRoom: 'Create a room and group for these travelers',
  hotelOccupancy: 'Room {{number}} · {{adults}} adults · child ages: {{ages}}',
  sourceCostHint:
    'Costs and conditions preserve the original search. You can adjust sales and allocations. Search again to change dates.',
  hotelImageMissing: 'Photo unavailable',
  hotelLocation: 'View location',
  hotelLocationMissing: 'Location unavailable',
  hotelBoardMissing: 'Board pending',
  hotelCaptured: 'Search price captured',
  hotelOccupancyChanged: 'Occupancy changed. This price preserves the previous search; search again to update it.',
  hotelChargesReview: 'Charges to review',
  hotelConditions: 'View information and conditions',
  hotelBinding: 'Reported binding price',
  hotelMinimum: 'Reported minimum selling price',
  hotelRoomAllocation: 'The supplier provided a total; the room breakdown is a commercial allocation.',
  yes: 'Yes',
  no: 'No',
  hotelIssues: {
    occupancy_incomplete: 'The offer does not detail every requested room. Cost remains pending.',
    cost_basis_unknown:
      'The supplier does not identify a net cost. Review the offer or add a manual service with a confirmed cost.',
    charges_incomplete: 'Additional charges may be missing; review before booking.',
    payment_pending: 'Deposit and due dates await confirmed conditions.',
  },

  backgroundError: 'Could not refresh the saved version. Your edits are still here.',
  accessRefreshError: 'Could not confirm quote access. Your edits are preserved; retry before saving.',
  invalidRoom: 'Check the name, adult count and child ages (0–17). Up to 100 travelers.',
  rowTotals: 'Total amounts for this row and its participants.',
  createError: 'Could not confirm creation. Retry to recover the same proposal.',
  moveUp: 'Move block up',
  moveDown: 'Move block down',
  discardLocal: 'Discard local edits and load the saved version?',
  saveAndLeave: 'Save and leave',
  currencyChange:
    'Fixed sales, allocations, discounts and deposit will be converted at this rate. Supplier costs keep their currencies. Re-enter other exchange rates relative to the new currency afterward.',
  addPriceRow: 'Add price row (ADT / CHD / INF)',
  title: 'Quotes',
  subtitle: 'Build the trip, compare options and refine the proposal.',
  open: 'View quotes',
  newQuote: 'New proposal',
  empty: 'There are no quotes in this case yet.',
  create: 'Create proposal',
  back: 'Back',
  close: 'Close',
  retry: 'Retry',
  loading: 'Loading…',
  saved: 'Saved',
  dirty: 'Unsaved changes',
  saving: 'Saving…',
  error: 'Could not save. Your edits are still here.',
  conflict: 'Another advisor saved changes. Your edits are preserved so you can choose how to continue.',
  saveCopy: 'Save my edits as another proposal',
  loadRemote: 'Load current version',
  unsaved: 'There are unsaved changes',
  unsavedDetail: 'Keep editing or close and discard these changes.',
  keepEditing: 'Keep editing',
  discard: 'Close without saving',
  loadError: 'Could not load this information.',
  case: 'Case #{{id}}',
  proposalTitle: 'Proposal name',
  updated: 'Updated {{date}}',
  privateDraft: 'Internal draft',
  previewOnly: 'This proposal has not been published yet.',
  travelers: 'Travelers and rooms',
  traveler: 'Traveler {{number}}',
  adult: 'Adult {{number}}',
  minor: 'Child {{number}}',
  travelerCount: '{{count}} travelers',
  adults: 'Adults',
  minorAges: 'Children’s ages',
  agesHint: 'One age per child, for example: 8, 12.',
  invalidAges: 'Enter whole ages between 0 and 17.',
  age: 'Age',
  addRoom: 'Add room',
  roomName: 'Room name',
  roomNumber: 'Room {{number}}',
  family: 'Family / group',
  newFamily: 'New family / group',
  familyName: 'Group name',
  familyNumber: 'Family {{number}}',
  rooms: 'Rooms',
  families: 'Families',
  noRoom: 'No room',
  noFamily: 'No family',
  noTravelers: 'Add rooms or start with services. Names and documents are not required.',
  removeTraveler: 'Remove traveler',
  removeTravelerDetail:
    'Service prices are preserved. Affected allocations will be updated; review them after removing the traveler.',
  remove: 'Remove',
  cancel: 'Cancel',
  add: 'Add',
  apply: 'Apply',
  confirm: 'Confirm',
  name: 'Name',
  servicesTitle: 'Trip services',
  sharedServices: 'Shared services',
  reviewPending: 'Review',
  pricingIssue: {
    selection_missing: 'Choose an option for this service.',
    components_missing: 'This option has no services yet.',
    exchange_rate_missing: 'The cost exchange rate is missing.',
    cost_unknown: 'The cost still needs confirmation.',
    sale_unknown: 'Set the selling price.',
    participants_missing: 'Choose who is taking this service.',
    discount_pending: 'A discount is pending calculation.',
    deposit_pending: 'Set the expected deposit.',
    balance_date_pending: 'Set the expected balance date.',
    payment_dates_inverted: 'The balance date cannot be before the deposit date.',
  },
  addServiceMenu: 'Add service',
  moreActions: 'More actions',
  searchNotEnabled: 'Search not enabled',
  manualSearchHint: 'You can add any service manually, even when its search is not enabled.',
  backToLibrary: 'Back to library',
  libraryChooseHotel: 'Choose as preferred hotel',
  addService: 'Add manual service',
  editService: 'Edit service',
  serviceTitle: 'Service name',
  serviceType: 'Service type',
  description: 'Description for the proposal',
  startDate: 'From',
  endDate: 'Until',
  participants: 'Participants',
  allTravelers: 'All travelers',
  addAlternative: 'Add alternative',
  addComponent: 'Add service to this option',
  optionTitle: 'Option name',
  chosen: 'Selected',
  choose: 'Select',
  optional: 'Optional',
  included: 'Included',
  include: 'Include in the trip',
  emptyServices: 'Add your first service. Offer alternatives and combine services in blocks.',
  alternative: 'Option {{number}}',
  edit: 'Edit',
  deleteOption: 'Remove option',
  deleteBlock: 'Remove block',
  blockName: 'Block name',
  deleteConfirm: 'Remove this item from the proposal?',
  cost: 'Cost',
  sale: 'Sale',
  margin: 'Margin on sale (%)',
  pricing: 'Price and margin',
  fixedSale: 'Sale price',
  useMargin: 'Calculate by margin',
  useDefault: 'Use proposal margin',
  net: 'Net',
  commissionable: 'Commissionable retail price',
  pvp: 'Retail price',
  commission: 'Commission',
  currency: 'Currency',
  pending: 'To confirm',
  unknownCost: 'Leave the cost pending and set a sale price if needed.',
  invalidMoney: 'Check the amount and currency decimals.',
  invalidForm: 'Check the service details.',
  invalidMargin: 'Margin must be below 100%.',
  invalidCommission: 'Commission cannot exceed the retail price.',
  advanced: 'Price and conditions details',
  splitRooms: 'Price by room',
  splitFamilies: 'Price by family',
  priceRow: 'Group {{number}}',
  fareType: 'Fare type',
  unclassified: 'Unclassified',
  allocation: 'Commercial allocation',
  equalSplit: 'Equal shares',
  weightedSplit: 'By weights / percentages',
  amountSplit: 'By amounts',
  weight: 'Relative weight',
  amount: 'Amount',
  allocationHint: 'A zero weight excludes a traveler from the allocation without removing them from the service.',
  payments: 'Deposit and balance terms',
  refundable: 'Refundable',
  nonrefundable: 'Full payment / nonrefundable',
  conditionsUnknown: 'Conditions to confirm',
  supplierDue: 'Supplier deadline',
  penaltyDate: 'Penalty start',
  commitment: 'Cost due now',
  destinationCharges: 'Charges payable at destination',
  addCharge: 'Add charge',
  summary: 'Trip summary',
  total: 'Selected trip total',
  profit: 'Profit',
  deposit: 'Expected deposit',
  balance: 'Expected balance',
  priceSettings: 'Adjust prices and terms',
  loss: 'Some services are sold below cost. Review the details before publishing.',
  incomplete: 'Some prices or conditions are still pending.',
  previewError: 'Check prices and allocations to calculate the summary.',
  recalculating: 'Updating amounts…',
  details: 'View details',
  defaultMargin: 'Suggested margin (%)',
  exchangeRates: 'Commercial exchange rates',
  rate: 'Rate into sale currency',
  addRate: 'Add exchange rate',
  discounts: 'Discounts',
  addDiscount: 'Add discount',
  scope: 'Apply to',
  proposal: 'Whole proposal',
  option: 'Option',
  percent: 'Percentage (%)',
  pendingDeposit: 'To be defined',
  automatic: 'Automatic from services',
  fixedDeposit: 'Fixed amount',
  percentDeposit: 'Percentage of sale',
  depositDate: 'Deposit date',
  balanceDate: 'Balance date (manual override)',
  penaltyLead: 'Days before penalty starts',
  tripLead: 'Days before the trip',
  settingsHelp: 'Customer collections remain in the sales order. Set the offered terms here.',
  removeSplit: 'Return to equal allocation',
  columns: { group: 'Group', total: 'Sale', cost: 'Cost', deposit: 'Deposit', balance: 'Balance' },
  services: {
    flight: 'Flight',
    hotel: 'Hotel',
    transfer: 'Transfer',
    activity: 'Activity',
    ferry: 'Ferry',
    train: 'Train',
    bus: 'Bus',
    car: 'Car',
    esim: 'eSIM',
    pass: 'Pass',
    circuit: 'Circuit',
    insurance: 'Insurance',
    other: 'Other service',
  },
};
